import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { DEFAULT_SEO, LEGAL_SEO, SITE_URL, getLegalPage, isPrivateRoute } from '../lib/seo';

export function SeoHead() {
  const { pathname } = useLocation();

  if (isPrivateRoute(pathname)) {
    return (
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
    );
  }

  const legalPage = getLegalPage(pathname);
  if (legalPage && LEGAL_SEO[legalPage]) {
    const { title, description } = LEGAL_SEO[legalPage];
    const canonical = `${SITE_URL}/legal/${legalPage}`;
    return (
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={canonical} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={DEFAULT_SEO.locale} />
        <meta property="og:image" content={DEFAULT_SEO.image} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={DEFAULT_SEO.image} />
      </Helmet>
    );
  }

  return (
    <Helmet>
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={`${SITE_URL}/`} />
    </Helmet>
  );
}
